import { render, staticRenderFns } from "./pub_journal.vue?vue&type=template&id=626efcae&scoped=true"
import script from "./pub_journal.vue?vue&type=script&lang=js"
export * from "./pub_journal.vue?vue&type=script&lang=js"
import style0 from "./pub_journal.vue?vue&type=style&index=0&id=626efcae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626efcae",
  null
  
)

export default component.exports